export class Loading {
  loading = '';
  loadingComponent = '';
  constructor(loading) {
    this.loading = loading;
  }
  openLoading() {
    this.loadingComponent = this.loading.open({
      container: null
    });
    setTimeout(() => this.loadingComponent.close(), 10000);
  }
  closeLoading() {
    this.loadingComponent.close();
  }
}
